import NextLink from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import { TabNav, TabNavItem } from 'shopper/components/TabNav';

import { sendEvent } from 'lib/gtag';
import { stripQs } from 'lib/request';

import LINKS from 'constants/links';

const TABS = [
  {
    name: 'Sugerir oferta',
    link: LINKS.NEW_OFFER,
    onClick: (gaEventCategory) =>
      sendEvent({ category: gaEventCategory, action: 'tab_offers' }),
  },
  {
    name: 'Sugerir cupom',
    link: LINKS.NEW_COUPON,
    onClick: (gaEventCategory) =>
      sendEvent({ category: gaEventCategory, action: 'tab_coupons' }),
  },
  {
    name: 'Novo tópico',
    link: LINKS.NEW_THREAD,
    onClick: (gaEventCategory) =>
      sendEvent({ category: gaEventCategory, action: 'tab_forum' }),
  },
];

const SuggestNewItemTabNav = ({ className, gaEventCategory, ...rest }) => {
  const router = useRouter();

  const pathname = stripQs(router.asPath);

  return (
    <TabNav className={twMerge('justify-center', className)} {...rest}>
      {TABS.map(({ name, link, onClick }, index) => {
        const isCurrTab = link === pathname;

        return (
          <NextLink key={index} href={link} prefetch={false} passHref>
            <TabNavItem
              active={isCurrTab}
              as="a"
              className="w-full px-0 text-sm md:px-10 md:text-base"
              size="size1"
              onClick={() => {
                onClick(gaEventCategory);
              }}
            >
              {name}
            </TabNavItem>
          </NextLink>
        );
      })}
    </TabNav>
  );
};

SuggestNewItemTabNav.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
};

export default SuggestNewItemTabNav;
